module.exports = __webpack_public_path__ + "img/muerte_cointreasure.841fc54.png";